import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import classNames from 'classnames';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC, MouseEvent } from 'react';
import './styles.css';

interface Props {
  type: 'empty' | 'emptyStpiIsolate' | 'missing' | 'hidden';
  onClick?: (e: MouseEvent) => void;
}

export const GraphPathWarning: FC<Props> = ({ type, onClick }) => {
  const {
    canvasGraph: { graphPathWarning: msgGraphPathWarning },
  } = useLocale();

  return (
    <Tooltip content={msgGraphPathWarning[type]}>
      <i
        className={classNames(
          'fa ml-lgu-2',
          type === 'hidden' ? 'fa-eye' : 'fa-exclamation-circle',
          `graph-path-warning__${type}`,
          onClick && `graph-path-warning__${type}--clickable`,
        )}
        onClick={onClick}
      />
    </Tooltip>
  );
};
